const refer = {
  /**
   * 获得参考题目ID列表
   * @param {String} questionId
   * @returns {Array|*}
   */
  getReferId (questionId) {
    let question = this.indexes[questionId].data
    let answer = this.indexes[questionId].answer
    let referIds = []
    if (question.type === 'select') {
      // 存在选项的参考目标
      let selectedOptionId = answer.selectedOptionId[0]
      if (selectedOptionId) {
        return this.indexes[questionId + selectedOptionId].data.referIds
      }
    }
    if (question.referIds) {
      return question.referIds
    }
    return referIds
  },

  /**
   * 获得参考题目列表
   * @param {String} questionId
   * @returns {Array|*}
   */
  getReferQuestion (questionId) {
    let referQuestions = []
    this.getReferId(questionId).forEach((questionId) => {
      referQuestions.push(this.indexes[questionId])
    })
    return referQuestions
  }
}

export default refer



// WEBPACK FOOTER //
// ./src/views/question-review/review/refer.js